
@switch (mode) {
  @case ('image') {
    <div class="tile image fx-layout-column fx-gap--8px">
      <a [routerLink]="tile.link" [title]="tile.title">
        <img [alt]="tile.title" loading="lazy" [src]="tile.image" />
      </a>
      @if (tile.title) {
        <div class="title fx-align--center-x" [innerHtml]="tile.title"></div>
      }
      @if (tile.caption) {
        <div class="caption" [innerHtml]="tile.caption"></div>
      }
    </div>
  }
  @case ('hero') {
    <div class="tile hero">
      @if (tile.image) {
        <div >
          @if (tile.title) {
            <a [routerLink]="tile.link" class="title large hide-xs" [innerHtml]="tile.title"></a>
          }
          <a [routerLink]="tile.link" [title]="tile.title">
            <img loading="lazy" [src]="tile.image" [alt]="tile.title" />
          </a>
        </div>
      }
      <div>
        @if (tile.title) {
          <a [routerLink]="tile.link" class="title large hide-xs" [innerHtml]="tile.title"></a>
        }
        @if (tile.caption) {
          <div class="caption" [innerHtml]="tile.caption"></div>
        }
        <div class="read-more">
          <button mat-flat-button color="primary">
            <a [routerLink]="tile.link">
              READ MORE
            </a>
          </button>
        </div>
      </div>
    </div>
  }
  @case ('list') {
    <div class="tile">
      @if (tile.title) {
        <a [routerLink]="tile.link" [title]="tile.title" class="title" [innerHtml]="tile.title"></a>
      }
      @if (tile.caption) {
        <div class="caption" [innerHtml]="tile.caption"></div>
      }
      <a [routerLink]="tile.link" class="read-more">read more &raquo;</a>
    </div>
  }
  @case ('icon') {
    <div class="icon sm">
      <div class="title-block">
        <mat-icon [svgIcon]="tile.icon" class="main-help-icon "></mat-icon>
        @if (tile.title) {
          <a [routerLink]="tile.link" class="main-help-title" [innerHtml]="tile.title"></a>
        }
      </div>
      @if (tile.caption) {
        <div class="help-caption" [innerHtml]="tile.caption"></div>
      }
    </div>
  }
  @default {
    <div class="tile fx-layout-column fx-gap--16px">
      <div class="heading fx-layout-row fx-gap--16px fx-align--x-center">
        @if (tile.title && tile.link) {
          <button mat-icon-button color="secondary" [routerLink]="tile.link" class="title" [ngClass]="{'title-center': tile.icon}">
            @if (tile.icon) {
              <mat-icon [svgIcon]="tile.icon" ></mat-icon>
            }
          </button>
        }
        <h3 [innerHtml]="tile.title" class="fx-flex-grow"></h3>
      </div>
      <div></div>
      @if (tile.image) {
        <a [routerLink]="tile.link" [title]="tile.title">
          <img loading="lazy" [src]="tile.image" [alt]="tile.title" />
        </a>
      }
      @if (tile.caption) {
        <div class="caption" [innerHtml]="tile.caption"></div>
      }
      <div class="fx-flex-grow"></div>
      @if (tile.link) {
        <div class="read-more fx-align--end-x">
          @if (linkStyle ==='text') {
            <button mat-stroked-button color="secondary">
              <a [routerLink]="tile.link">
                READ MORE
              </a>
            </button>
          }
          @if (linkStyle ==='button') {
            <button mat-flat-button color="secondary">
              <a [routerLink]="tile.link">
                READ MORE
              </a>
            </button>
          }
        </div>
      }
      <div></div>
    </div>
  }
}
